import { Redirect } from "react-router";
//bring in logout as props
export const Logout = () => {
	localStorage.removeItem("token");
	return <Redirect to="/login"></Redirect>;
};

export default Logout;
